import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import posed from "react-pose";

const PoseOverlay = posed.div({
  open: {
    delayChildren: 250,
    staggerChildren: 50
  },
  closed: { delay: 500 }
});

const PoseItem = posed.div({
  open: { x: 0, opacity: 1 },
  closed: { x: 100, opacity: 0 }
});

class MenuList extends PureComponent {
  static propTypes = {
    items: PropTypes.array.isRequired,
    itemIcon: PropTypes.string,
    onSelect: PropTypes.func
  };

  static defaultProps = {
    itemIcon: null,
    onSelect: () => {}
  };

  state = {
    isOpen: false
  };

  componentDidMount() {
    this.setState({ isOpen: true });
  }

  renderItemIcon = () => {
    if (this.props.itemIcon) {
      return <i className={this.props.itemIcon} />;
    }

    return null;
  };

  renderMenuItem = item => {
    return (
      <PoseItem key={item.id} className="menu-list-item">
        <a
          href={"#" + item.name}
          role="menuitem"
          onClick={e => {
            e.preventDefault();
            this.props.onSelect(item);
          }}
        >
          {this.renderItemIcon()}
          <span>{item.name}</span>
          <i className="icon-caret-right" />
        </a>
      </PoseItem>
    );
  };

  render() {
    if (this.props.items.length) {
      return (
        <PoseOverlay
          className="menu-list-container"
          pose={this.state.isOpen ? "open" : "closed"}
        >
          {this.props.items.map(item => this.renderMenuItem(item))}
        </PoseOverlay>
      );
    }

    return (
      <div className="menu-list-container">
        <div className="empty">
          <i className="icon-warning" />
          <span>Menu is not available</span>
        </div>
      </div>
    );
  }
}

export default MenuList;
